module.exports = __webpack_public_path__ + "static/media/certificate.dd1d2a67.svg";